import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; 
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux'; // Make sure you're importing this
import nex_store from './redux/store'; // Your redux store
import { msalConfig } from './authConfig';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import $ from 'jquery';

window.$ = $;
window.jQuery = $;
ModuleRegistry.registerModules([AllCommunityModule]);
const msalInstance = new PublicClientApplication(msalConfig);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

msalInstance.initialize().then(() => {
root.render(   

<React.StrictMode>
<Provider store={nex_store}>  {/* Make sure Provider wraps everything */}
        <App />
      </Provider>
 
  <ToastContainer />
 </React.StrictMode>
);
});


